import styled from 'styled-components'
import theme from 'styles/theme'
import Slider from 'react-slick'
import { Element } from 'react-scroll'

export const Container = styled(Element)`
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.space[4]} 0;

  ${theme.mediaQueries.medium} {
    padding: ${theme.space[4]} 0;
  }
`

export const ProductList = styled.div`
  margin: ${theme.space[6]} 0 0 0;
  scroll-behavior: smooth;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledSlider = styled(Slider)`
  width: 100%;

  ${theme.mediaQueries.medium} {
    width: 1180px;

    .slick-track {
      margin: auto;
    }
  }
`

export const ProductContainer = styled.div`
  aspect-ratio: 10 / 16;
  @supports not (aspect-ratio: 10 / 16) {
    ${(props) => `height: ${props.width * 1.6}px;`}
  }
  padding: 0 ${theme.space[2]};
`

export const Background = styled.div`
  position: absolute;
  width: 100vw;
  height: 50%;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #${(props) => props.hexValue};
  opacity: 0.3;
`

export const CarouselControlsWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  bottom: 125px;
  height: 50px;
  width: 150px;
`

export default {
  Container,
  ProductList,
  ProductContainer,
  StyledSlider,
  Background,
  CarouselControlsWrapper,
}
